/**
 * Balade en Provence · PDP Hollis (drawers + tabs)
 */
(function () {
  function initDrawers(root) {
    if (root.dataset.bepDrawersReady === 'true') return;
    root.dataset.bepDrawersReady = 'true';

    const overlay = root.querySelector('[data-bep-drawer-overlay]');
    const drawers = [...root.querySelectorAll('[data-bep-drawer]')];
    let active = null;
    let opener = null;

    function focusableElements(drawer) {
      return [...drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')];
    }

    function closeDrawer() {
      if (!active) return;
      active.setAttribute('hidden', '');
      active.setAttribute('aria-hidden', 'true');
      overlay?.setAttribute('hidden', '');
      document.documentElement.classList.remove('bep-pdp-drawer-open');
      root.querySelectorAll('[data-bep-drawer-open]').forEach((btn) => {
        btn.setAttribute('aria-expanded', 'false');
      });
      active = null;
      opener?.focus();
      opener = null;
    }

    function openDrawer(id) {
      const drawer = root.querySelector(`[data-bep-drawer="${id}"]`);
      if (!drawer) return;
      closeDrawer();
      active = drawer;
      opener = root.querySelector(`[data-bep-drawer-open="${id}"]`);
      drawer.removeAttribute('hidden');
      drawer.setAttribute('aria-hidden', 'false');
      overlay?.removeAttribute('hidden');
      document.documentElement.classList.add('bep-pdp-drawer-open');
      opener?.setAttribute('aria-expanded', 'true');
      drawer.querySelector('.bep-pdp-drawer__close')?.focus();
    }

    root.querySelectorAll('[data-bep-drawer-open]').forEach((btn) => {
      btn.addEventListener('click', () => openDrawer(btn.getAttribute('data-bep-drawer-open')));
    });

    root.querySelectorAll('[data-bep-drawer-close]').forEach((btn) => {
      btn.addEventListener('click', closeDrawer);
    });

    overlay?.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeDrawer();
      if (e.key !== 'Tab' || !active) return;

      const focusables = focusableElements(active);
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  function initTabs(section) {
    if (section.dataset.bepTabsReady === 'true') return;
    section.dataset.bepTabsReady = 'true';

    const tabs = [...section.querySelectorAll('[data-bep-tab]')];
    const panels = [...section.querySelectorAll('[data-bep-tab-panel]')];
    if (!tabs.length) return;

    function activate(id) {
      tabs.forEach((tab) => {
        const on = tab.getAttribute('data-bep-tab') === id;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.setAttribute('tabindex', on ? '0' : '-1');
      });
      panels.forEach((panel) => {
        const on = panel.getAttribute('data-bep-tab-panel') === id;
        panel.classList.toggle('is-active', on);
        panel.hidden = !on;
      });
    }

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => activate(tab.getAttribute('data-bep-tab')));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const currentIndex = tabs.indexOf(tab);
        let nextIndex = currentIndex;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        const nextTab = tabs[nextIndex];
        activate(nextTab.getAttribute('data-bep-tab'));
        nextTab.focus();
      });
    });
  }

  function initProductEditorial(scope = document) {
    scope.querySelectorAll('[data-bep-pdp-drawers]').forEach(initDrawers);
    scope.querySelectorAll('.bep-pdp-hollis-tabs').forEach(initTabs);
  }

  // The reassurance sits outside the form: keep it in sync with its variant.
  document.addEventListener('variant:updated', (event) => {
    const section = event.target.closest('.bep-pdp');
    const support = section?.querySelector('.bep-pdp-purchase-support');
    if (!support) return;
    const available = event.detail?.resource?.available === true;
    support.querySelector('.bep-pdp-stock')?.classList.toggle('bep-pdp-stock--unavailable', !available);
    const label = support.querySelector('[data-bep-stock-label]');
    if (label) label.textContent = available ? support.dataset.availableLabel : support.dataset.unavailableLabel;
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initProductEditorial(), { once: true });
  } else {
    initProductEditorial();
  }

  document.addEventListener('shopify:section:load', (event) => initProductEditorial(event.target));
})();
